// import { IAppState } from "src/types/appStateInterface";

import { IAppState } from "../types/appStateInterface";

export const initialAppState: IAppState = {
  // loginState: {
  //   isLoggedIn: false,
  //   isSignnedIn: true,
  // },
  // userState: {
  //   accessToken: '',
  //   userId: '',
  //   userName: '',
  //   isGuestUser: true,
  // },
  pageLoaderState: {
    loading: false,
    loadingMessage: "",
    snackbarShow: false,
    snackbarMessage: "",
    snackbarSeverity: "success",
  },
};
